import { Typography } from 'antd'
import { useDispatch } from 'react-redux'
import { useEffect, useState } from 'react'
import { IAM_URL } from "../../utils/Config"
import { getTimeLineData } from "../../store/actions/CommonActions"
import {setContentLoading}  from '../../store/reducers/CommonReducer'
import { getTranslated } from '../../utils/CommonUtils'

const TimelineList = () => {
  const { Title, Text, Paragraph } = Typography
  const dispatch = useDispatch()
  const [resData, setResData] = useState([])

  useEffect(() => {
    const url = `${IAM_URL}/appinfo/newfeatures`

    dispatch(setContentLoading(true))
    dispatch(getTimeLineData(url, (data) => {
      if (data) {
        setResData(data)
      } else {
        console.error("Failed to fetch timeline data")
      }
      dispatch(setContentLoading(false))
    }))
  }, [])

  const formatTimestamp = (timestamp) => {
    const dateObj = new Date(timestamp)
    return dateObj.toLocaleString('en-US', {
      month: 'long',
      year: 'numeric',
    })
  }

  return (
    <div className="timeline-container">
      {(resData || []).map((item, index) => (
        <div key={index} className="timeline-section">
          <Title level={5} className="timeline-title">
            <Text strong className="timeline-date">
              {`${formatTimestamp(item?.timestamp)} - ${item?.dateToPublishInUmc}`} 
            </Text>{" "}
            {getTranslated(dispatch,item?.title )}
          </Title>
          <Paragraph className="timeline-description">
            {getTranslated(dispatch,item?.description )}
          </Paragraph>
        </div>
      ))}
    </div>
  )
}

export default TimelineList
